// extracted by mini-css-extract-plugin
export default {"ame-spin":"ame-spin_SjD6A","ameSpin":"ame-spin_SjD6A","fullscreen":"fullscreen_MDwQi"};